import { render, staticRenderFns } from "./InfoPrincipal.vue?vue&type=template&id=713c27a0&"
import script from "./InfoPrincipal.vue?vue&type=script&lang=js&"
export * from "./InfoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports